import { Texts } from "@/components/tools/Texts.js";

export default {
    install(Vue, options) {
        const textHelper = new Texts(options?.defaultLanguage || "en");
        // Add globally accessible property
        Vue.prototype.$texts = textHelper;
    }
};